import { createRoot } from 'react-dom/client'
import './assets/styles/global.css'
import App from './App.tsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { getQueryClient } from './config/queryClient.config.ts'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SnackbarProvider } from 'notistack'
import Toaster from './components/ui/toaster.tsx'

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={getQueryClient()}>
    <SnackbarProvider
      onClose={() => { }}
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={5000}
    >
      <App />
    </SnackbarProvider>
    <Toaster />
    <ReactQueryDevtools initialIsOpen={false} position={'bottom'} />
  </QueryClientProvider>
)
